'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'bicycle';
var width = 640;
var height = 512;
var aliases = [128690];
var unicode = 'f206';
var svgPathData = ['M64 352c0 44.2 35.8 80 80 80 38.7 0 71-27.5 78.4-64l-73.2 0c-20.2 0-33.4-21.3-24.3-39.4l28.1-56.1c-2.9-.3-5.9-.5-8.9-.5-44.2 0-80 35.8-80 80zm352 0c0 44.2 35.8 80 80 80s80-35.8 80-80-35.8-80-80-80c-4 0-8 .3-11.8 .9l33.4 68.6c5.8 11.9 .8 26.3-11.1 32.1s-26.3 .8-32.1-11.1L441 293.9c-15.4 14.6-25 35.2-25 58.1z', 'M331.7 43.3C336 36.3 343.7 32 352 32l104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-65.6 0 72.2 148.4c10.7-2.9 21.9-4.4 33.4-4.4 70.7 0 128 57.3 128 128s-57.3 128-128 128-128-57.3-128-128c0-42 20.2-79.2 51.4-102.6l-20.4-41.9-73.5 147c-2.3 4.8-6.3 8.8-11.4 11.2-.6 .3-1.2 .5-1.8 .7-2.9 1.1-5.9 1.6-8.9 1.5L271 368c-7.9 63.1-61.7 112-127 112-70.7 0-128-57.3-128-128S73.3 224 144 224c10.8 0 21.2 1.3 31.2 3.8l28.5-56.9-11.5-26.9-40.2 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l56 0c9.6 0 18.3 5.7 22.1 14.5l14.3 33.5 123.7 0-37.7-77.5c-3.6-7.4-3.2-16.2 1.2-23.2zM228.5 228.7l-45.6 91.3 84.8 0-39.1-91.3zM305.7 287l47.5-95-88.2 0 40.7 95zm168.7 75.5L441 293.9c-15.4 14.6-25 35.2-25 58.1 0 44.2 35.8 80 80 80s80-35.8 80-80-35.8-80-80-80c-4 0-8 .3-11.8 .9l33.4 68.6c5.8 11.9 .8 26.3-11.1 32.1s-26.3 .8-32.1-11.1zM149.2 368c-20.2 0-33.4-21.3-24.3-39.4l28.1-56.1c-2.9-.3-5.9-.5-8.9-.5-44.2 0-80 35.8-80 80s35.8 80 80 80c38.7 0 71-27.5 78.4-64l-73.2 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBicycle = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;